import React, { CSSProperties, useRef } from 'react';
import cx from 'classnames';
import styled from 'styled-components';
import { TextChatMessage } from '../../types';
import TextChatBody from './TextChatBody';
import { CallRequestType } from '../../customer-call-sdk';

const StyledTextChat = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 420px;
    background-color: #000000;

    transition: display 1s linear;

    .chat-header {
        background-color: rgba(185, 192, 199, 0.18);

        height: 90px;
        display: flex;
        align-items: center;
        padding: 32px;
    }
    .chat-header-title {
        font-size: 34px;
        color: #fff;
        font-weight: bold;
    }
    .chat-body {
        flex: 1;
    }
    .chat-footer {
        padding: 16px 24px;
    }
    .message-box {
        background-color: rgba(255, 255, 255, 0.3);
        border-radius: 0.5rem;
        color: #fff;
        width: 100%;
        height: 70px;
        outline: none;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #fff;
        resize: none;
    }
    .message-box::placeholder {
        color: #ddd;
        font-size: 1rem;
    }
`;

interface TextChatProps {
    messages: TextChatMessage[];
    className?: string;
    style?: CSSProperties;
    onSendMessage: (text: string) => void;
    chatVisible: boolean;
    id?: string;
    callRequestType: CallRequestType;
    onFocus?: (focused: boolean) => void;
}
/**
 * Text chat component
 */
const TextChat: React.FC<TextChatProps> = ({
    messages,
    className,
    onSendMessage,
    callRequestType,
    onFocus,
    ...props
}) => {
    const textInputRef = useRef<HTMLTextAreaElement | null>(null);
    const handleSendBtnClick = () => {
        if (textInputRef.current) {
            const trimmedMessage = textInputRef.current.value.trim();
            if (trimmedMessage) {
                onSendMessage(trimmedMessage);
                textInputRef.current.value = '';
            }
        }
    };

    const handleKeyUp = (event: React.KeyboardEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (event.key === 'Enter') {
            handleSendBtnClick();
        }
    };

    return (
        <StyledTextChat className={cx(className)} {...props}>
            <TextChatBody
                className="chat-body"
                messages={messages}
                callRequestType={callRequestType}
            />
            <div className="chat-footer">
                <textarea
                    placeholder="Send a message"
                    className="message-box"
                    onKeyUp={handleKeyUp}
                    ref={textInputRef}
                    id="text-chat-input"
                    onFocus={() => onFocus?.(true)}
                    onBlur={() => onFocus?.(false)}
                    aria-required="true"
                    aria-label="Chat Box"
                />
            </div>
        </StyledTextChat>
    );
};
TextChat.displayName = 'TextChat';
export default TextChat;
